module.exports = __webpack_public_path__ + "img/icon-loading.b610d46d.png";